var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33636 2.26667C6.73636 2.26667 8.0697 2.8 9.0697 3.8C11.1364 5.86667 11.1364 9.26667 9.0697 11.3333C7.8697 12.6 6.20303 13.0667 4.60303 12.8667L4.93636 11.5333C6.0697 11.6667 7.2697 11.2667 8.13636 10.4C9.6697 8.86667 9.6697 6.33333 8.13636 4.73333C7.40303 4 6.33636 3.6 5.33636 3.6V6.66667L2.00303 3.33333L5.33636 0V2.26667ZM1.53636 11.3333C-0.196969 9.6 -0.463636 6.93333 0.736364 4.86667L1.73636 5.86667C1.00303 7.33333 1.2697 9.2 2.53636 10.4C2.8697 10.7333 3.2697 11 3.73636 11.2L3.33636 12.5333C2.6697 12.2667 2.0697 11.8667 1.53636 11.3333Z",
    fill: "#285192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restart-icon.0747240ac6bf6c223a5285d39958517e.svg";
export { ForwardRef as ReactComponent };